import { render, staticRenderFns } from "./NonConformityCorrectiveAction.vue?vue&type=template&id=3ada4972&scoped=true&"
import script from "./NonConformityCorrectiveAction.vue?vue&type=script&lang=js&"
export * from "./NonConformityCorrectiveAction.vue?vue&type=script&lang=js&"
import style0 from "./NonConformityCorrectiveAction.vue?vue&type=style&index=0&id=3ada4972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada4972",
  null
  
)

export default component.exports